import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
interface SlideTitleProps {
  onContinue: () => void;
}
export function SlideTitle({
  onContinue
}: SlideTitleProps) {
  return <div className="h-full w-full flex flex-col items-center justify-center px-12 py-16 text-center relative" data-id="element-1090" data-mp="3cka8jx1f4865">
      <div className="z-10 max-w-4xl w-full space-y-8" data-id="element-1091" data-mp="3gl3van34jgxg">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="space-y-4" data-id="element-1092" data-mp="2jvuvvh5re1xz">
          <p className="text-sm md:text-base text-teal-400 font-semibold uppercase tracking-[0.25em]" data-id="element-1093" data-mp="2sw14aomlobqa">
            Snakker LEO Presentation
          </p>
          <h1 className="text-5xl md:text-7xl font-serif text-white" data-id="element-1094" data-mp="2xokhvllaf6v3">
            Think Global <br data-id="element-1095" data-mp="214vaepxh3a9g" />
            <span className="text-teal-400" data-id="element-1096" data-mp="213agn2izfvcn">Act Local</span>
          </h1>
          <p className="text-xl md:text-2xl text-white/70 font-medium max-w-2xl mx-auto mt-6" data-id="element-1097" data-mp="255nivgyitb4o">
            One campaign engine. Many local executions.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="pt-8" data-id="element-1098" data-mp="1o62evj92vc0j"></motion.div>
      </div>
    </div>;
}